

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { EmailSenderComponent } from './email-sender.component';
import { EmailSenderRoutes } from './email-sender.routing';
import { TestEmailSenderComponent } from './test-email-sender/test-email-sender.component';

export function declaration() {
    return [EmailSenderComponent, TestEmailSenderComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class EmailSenderModule {
}

@NgModule({
    imports: [EmailSenderModule, EmailSenderRoutes],
    exports: [EmailSenderModule]
})
export class EmailSenderWithRouteModule {
}
